module.exports = __webpack_public_path__ + "img/ecology_card1.650512a6.png";